var map = {
	"./dashboard.vue": "f0P9",
	"./default.vue": "lfHO",
	"./error.vue": "nAus",
	"./login.vue": "8Ojl",
	"./mfa.vue": "XEFk"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kDKJ";


//////////////////
// WEBPACK FOOTER
// ./src/layouts nonrecursive ^\.\/.*\.vue$
// module id = kDKJ
// module chunks = 32